import React from 'react';

interface FieldShellProps {
  className?: string;
  label?: string;
  htmlFor?: string;
  error?: string | null;
  errorId?: string;
  /** Glyph shown inside the control, left of its value — matches the Personalizar mock. */
  glyph?: string;
  /** Extra control (e.g. a one-way toggle) shown next to the label instead of
   * its own row, so it never changes the form's height. When `label` is omitted
   * (flights "Fecha" → Solo ida), this becomes the only label-row content. */
  labelExtra?: React.ReactNode;
  children: React.ReactNode;
}

export const FieldShell: React.FC<FieldShellProps> = ({
  className,
  children,
  error,
  errorId,
  glyph,
  htmlFor,
  label,
  labelExtra,
}) => (
  <div className={['searcher-field', className].filter(Boolean).join(' ')}>
    {(label || labelExtra) && (
      <div className='searcher-field__label-row'>
        {label ? (
          <label className='searcher-field__label' htmlFor={htmlFor}>
            {label}
          </label>
        ) : (
          <span className='searcher-field__label-spacer' />
        )}
        {labelExtra}
      </div>
    )}
    <div
      className={['searcher-field__control-wrap', glyph && 'searcher-field__control-wrap--icon']
        .filter(Boolean)
        .join(' ')}
    >
      {glyph && (
        <span aria-hidden='true' className='searcher-field__glyph'>
          {glyph}
        </span>
      )}
      {children}
    </div>
    {error && (
      <p className='searcher-field__error' id={errorId} role='alert'>
        {error}
      </p>
    )}
  </div>
);
